// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1Sgc8","subheader":"ReorderModal_subheader__20HQJ","listWrap":"ReorderModal_listWrap__fNmuX"};